export default {
    DEFAULT_AUDIO: 'sv',
    SPOKEN_TEXT: 'sv-tal'
};



// WEBPACK FOOTER //
// ./src/js/constants/audio-track.js